import { render, staticRenderFns } from "./ShelterAreasArchived.vue?vue&type=template&id=673da7d1&scoped=true"
import script from "./ShelterAreasArchived.vue?vue&type=script&lang=js"
export * from "./ShelterAreasArchived.vue?vue&type=script&lang=js"
import style0 from "./ShelterAreasArchived.vue?vue&type=style&index=0&id=673da7d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673da7d1",
  null
  
)

export default component.exports